export default __webpack_public_path__ + "static/media/import.005e13cc.svg";